import PawModel from './PawModel';

class Bloc extends PawModel {
  static apiType = 'blocs';

  title?: string;
}

export default Bloc;